import React, { FC } from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import GlobalStyles from "../styles/GlobalStyles";

//Styles

interface Props {
  value?:any;
  disabled?:boolean;
  error?: boolean;
  label: string;
  helperText?: string;
  type: string;
  maxLength?: number;
  typeId?: string;
  focusedColor?: string;
  underlineColor?: string;
  capitalize?: string;
  placeholder?: string;
  autoComplete?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, data?: any) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const TextFieldComponent: FC<Props> = (p) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        width: "100%",
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        "& label.Mui-focused": {
          color: p.focusedColor || GlobalStyles.secondaryColor,
        },
        "& label": {
          color: GlobalStyles.thirdColor,
        },
        "& .MuiInput-underline:after": {
          borderBottomColor: p.underlineColor || GlobalStyles.secondaryColor,
        },
        "& .MuiInput-underline:before": {
          borderBottomColor: GlobalStyles.thirdColor,
        },
        "& label.Mui-error": {
          color: GlobalStyles.primaryColor,
        },
      },
    })
  );
  const inputProps = {
    maxLength: p.maxLength ? p.maxLength : 50,
    autoCapitalize: p.capitalize || "none",
    autoComplete: p.autoComplete || "on"
  };
  const classes = useStyles();
  return (
    <>
      <TextField
        inputProps={inputProps}
        label={p.label}
        error={p.error}
        type={p.type}
        helperText={p.helperText}
        className={classes.root}
        onChange={p.onChange}
        disabled={p.disabled}
        value={p.value}
        onKeyPress={p.onKeyPress}
        placeholder={p.placeholder}
      />
    </>
  );
};

export default TextFieldComponent;
